import { useState } from 'react'
import { Creator, CreatorOnboardingStep } from '../../../../gql/types'
import LOGO from '../../../../assets/logo/lancape_no_bg.png'
import classnames from 'classnames'
import { Icon, IconType } from '../../../../components'
import { Header } from '../Header'

const steps = [
  {
    id: '01',
    name: 'MY PROFILE',
    description: `Personal info and interests`,
    stepOnboarding: [
      CreatorOnboardingStep.setSourceChannel,
      CreatorOnboardingStep.setProfile,
      CreatorOnboardingStep.setAbout,
    ],
  },
  {
    id: '02',
    name: 'INTRO VIDEO',
    description: `For brands to know you`,
    stepOnboarding: [
      CreatorOnboardingStep.setInterests,
      CreatorOnboardingStep.setIntroVideo,
      CreatorOnboardingStep.setPortfolio,
    ],
  },
  {
    id: '03',
    name: 'SHIPPING ADDRESS',
    description: 'To receive your products',
    stepOnboarding: [
      CreatorOnboardingStep.setShippingAddress,
      CreatorOnboardingStep.setPaypalEmailAddress,
      CreatorOnboardingStep.agreeTerms,
      CreatorOnboardingStep.completed,
    ],
  },
]

interface Props {
  creator: Creator
  stepCurrent: CreatorOnboardingStep
}

const Steps = ({ creator, stepCurrent }: Props) => {
  const [indexCurrent, setIndexCurrent] = useState(null)
  const [percentStepCurrent, setPercentStepCurrent] = useState('')
  const [control, setControl] = useState('')

  const onSetPercent = (stepCurrent: CreatorOnboardingStep) => {
    switch (stepCurrent) {
      case CreatorOnboardingStep.setSourceChannel:
        setPercentStepCurrent('35%')
        break
      case CreatorOnboardingStep.setProfile:
        setPercentStepCurrent('80%')
        break
      case CreatorOnboardingStep.setAbout:
        setPercentStepCurrent('100%')
        break
      case CreatorOnboardingStep.setInterests:
        setPercentStepCurrent('35%')
        break
      case CreatorOnboardingStep.setIntroVideo:
        setPercentStepCurrent('80%')
        break
      case CreatorOnboardingStep.setPortfolio:
        setPercentStepCurrent('100%')
        break
      case CreatorOnboardingStep.setShippingAddress:
        setPercentStepCurrent('35%')
        break
      case CreatorOnboardingStep.setPaypalEmailAddress:
        setPercentStepCurrent('80%')
        break
      case CreatorOnboardingStep.agreeTerms:
        setPercentStepCurrent('95%')
        break
      case CreatorOnboardingStep.completed:
        setPercentStepCurrent('100%')
        break
      default:
        break
    }
    setControl(stepCurrent)
  }

  return (
    <div className='px-4 pt-4'>
      <div className=''>
        <Header
          creator={creator}
          timeLeft={null}
          title={null}
          description={null}
        />
      </div>
      <nav aria-label='progress' className='mt-4'>
        <ol className='flex space-y-0 space-x-4 md:space-x-8'>
          {steps.map((step, stepIdx) => (
            <li key={step.id} className='flex-1'>
              <div>
                {step.stepOnboarding.includes(stepCurrent) ? (
                  <>
                    {indexCurrent === null
                      ? (() => {
                          setIndexCurrent(stepIdx)
                          return null
                        })()
                      : null}
                    {control !== stepCurrent
                      ? (() => {
                          onSetPercent(stepCurrent)
                          return null
                        })()
                      : null}
                    <div className='overflow-hidden rounded-full bg-gray-200'>
                      <div
                        className='flex flex-col h-2 rounded-full bg-gray-800'
                        aria-current='step'
                        style={{ width: percentStepCurrent }}
                      ></div>
                    </div>
                  </>
                ) : stepIdx < indexCurrent ? (
                  <>
                    <div
                      className='flex flex-col h-2 rounded-full bg-gray-800'
                      aria-current='step'
                    ></div>
                  </>
                ) : (
                  <div className='h-2 rounded-full bg-gray-200' />
                )}
              </div>
            </li>
          ))}
        </ol>
      </nav>
    </div>
  )
}

export { Steps }
